import isFileGif from './isFileGif';
import isFileSvg from './isFileSvg';

const mediaServerUrl = process.env.VUE_APP_MEDIA_SERVER_URL;
const mediaResizeUrl = process.env.VUE_APP_PIRI_MEDIA_RESIZE_URL;

const getImageUrl = (path, width = '-') => {
  if (isFileGif(path) || isFileSvg(path) || width === "-") {
    return `${mediaServerUrl}${path}`;
  }

  return path ? `${mediaResizeUrl}/?uri=${path}&width=${width}` : '';
};

export default getImageUrl;
